module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"step":"Step","of":"of","developed":"Developed by","wepipe-forms":"wepipe forms"},"pt-BR":{"step":"Etapa","of":"de","developed":"Desenvolvido por","wepipe-forms":"wepipe forms"}}')
  delete Component.options._Ctor
}
